import axios from 'axios';

export const publishPost = async (postData) => {
    try {
        const token = localStorage.getItem('token');
        
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/publish`, postData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        console.error('Post publication error:', error.response ? error.response.data : error.message);
        throw error;
    }
};

export const publishEdit = async (postData) => {
    try {
        const token = localStorage.getItem('token');
        
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/publish_edit`, postData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        console.error('Post publication error:', error.response ? error.response.data : error.message);
        throw error;
    }
};

export const publishComment = async (postData) => {
    try {
        const token = localStorage.getItem('token');
        
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/comment/publish`, postData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        console.error('Post publication error:', error.response ? error.response.data : error.message);
        throw error;
    }
};
